import React, { ReactElement, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  RfUiMultiselect,
  RfUiAccordionCustom,
  RfUiButton,
  RfUiInput,
  RfUiSelect,
  RfUiModal,
} from 'renfe-components';
import { createStructuredSelector } from 'reselect';
import {
  makeSelectSociedadesParse,
  makeSelectCursosAuditoriaParse,
  makeSelectAlumnosAuditoriaParse,
  makeSelectProvinciasAuditoriaParse,
} from 'store/practicas/selectors';
import { makeSelectFiltros, makeSelectNombreFiltro, makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected, makesSelectFiltrosParse } from 'store/usuarios/selectors';
import { setSelectedAlumno, resetSelectedStudents } from 'store/app/actions';
import { makeSelectSelectedStudents } from 'store/app/selectors';
import {
  removeFilterAuditoria,
  setSelectedCursosAuditoria,
  setSelectedSociedadAuditoria,
  setSelectedProvinciaAuditoria,
  removeSelectedProvinciasAuditoria,
  removeSelectedCursosAuditoria,
  getSociedadesRequest,
  getFilterCursosByAlumnosAuditoriaRequest,
  setPracticasAuditoria,
  setPracticasAuditoriaCount,
} from 'store/practicas/actions';
import { submitFilters } from 'store/practicas/actions';
import { ErrorMessage } from 'components/ErrorMessage/ErrorMessage';
import { language } from '../../utils/literals';
import { isMobileOnly } from 'react-device-detect';
import { deleteSavedPagination } from 'utils/practiceUtils';
import { FilterContainer } from 'containers/filterContainer';
import { editarFiltroRequest, eliminarFiltroRequest, getFiltros, getFiltrosRequest, guardarFiltroRequest, removeFiltro, setFiltroFechaCreacion, setFiltroFechaModificacion, setFiltroId, setFiltroJson, setFiltroNombre, setFiltroNombrePagina } from 'store/usuarios/actions';
import { useHistory } from 'react-router';
import { RouteTypes } from 'consts';
import { getActualTime } from 'utils/dates-validators';
import { links } from 'pages/Audit';

const selectors = createStructuredSelector({
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  sociedades: makeSelectSociedadesParse(),
  provinciasAuditoriaParse: makeSelectProvinciasAuditoriaParse(),
  cursosAuditoria: makeSelectCursosAuditoriaParse(),
  alumnosAuditoria: makeSelectAlumnosAuditoriaParse(),
  selectedStudents: makeSelectSelectedStudents(),
  filtro: makeSelectFiltros(),
  filtros: makesSelectFiltrosParse(),
  nombreFiltro: makeSelectNombreFiltro(),
  cursosFiltro: makeSelectCursosAuditoriaParse(),
  sociedadesFiltro: makeSelectSociedadesParse(),
  alumnosFiltro: makeSelectAlumnosAuditoriaParse(),
  provinciasFiltro: makeSelectProvinciasAuditoriaParse(),
} as any);

const FilterAudit = (): ReactElement => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    profileActive,
    sociedades,
    provinciasAuditoriaParse,
    cursosAuditoria,
    alumnosAuditoria,
    selectedStudents,
    filtro,
    filtros,
    nombreFiltro,
    cursosFiltro,
    sociedadesFiltro,
    alumnosFiltro,
    provinciasFiltro,
  } = useSelector<any, any>(selectors);

  const [sociedadesSelectValue, setSociedadesSelectValue] = useState('');
  const [provinciasSelectValue, setProvinciasSelectValue] = useState('');
  const [cursosSelectValue, setCursosSelectValue] = useState('');
  const [alumnosSelectValue, setAlumnosSelectValue] = useState('');

  /**
   * Indican si el siguiente cambio de opciones debe provocar
   * un remount del RfUiMultiselect.
   *
   * Se inicializan a true para que, cuando lleguen los datos
   * por primera vez, el componente se vuelva a montar y
   * aparezca correctamente "Seleccionar todos".
   */
  const hasMultiselectOptions = (options: any): boolean => {
  if (Array.isArray(options)) {
    return options.length > 0;
  }

  if (typeof options === 'string') {
    try {
      const parsedOptions = JSON.parse(options);
      return Array.isArray(parsedOptions) && parsedOptions.length > 0;
    } catch {
      return false;
    }
  }

  return false;
};

const [sociedadResetKey, setSociedadResetKey] = useState(0);
const [provinciaResetKey, setProvinciaResetKey] = useState(0);
const [cursoResetKey, setCursoResetKey] = useState(0);
const [alumnoResetKey, setAlumnoResetKey] = useState(0);

const resetSociedadPending = useRef(true);
const resetProvinciaPending = useRef(true);
const resetCursoPending = useRef(true);
const resetAlumnoPending = useRef(true);



useEffect(() => {
  if (
    resetSociedadPending.current &&
    hasMultiselectOptions(sociedades)
  ) {
    setSociedadResetKey(k => k + 1);
    resetSociedadPending.current = false;
  }
}, [sociedades]);

useEffect(() => {
  if (
    resetProvinciaPending.current &&
    hasMultiselectOptions(provinciasAuditoriaParse)
  ) {
    setProvinciaResetKey(k => k + 1);
    resetProvinciaPending.current = false;
  }
}, [provinciasAuditoriaParse]);

useEffect(() => {
  if (
    resetCursoPending.current &&
    hasMultiselectOptions(cursosAuditoria)
  ) {
    setCursoResetKey(k => k + 1);
    resetCursoPending.current = false;
  }
}, [cursosAuditoria]);

useEffect(() => {
  if (
    resetAlumnoPending.current &&
    hasMultiselectOptions(alumnosAuditoria)
  ) {
    setAlumnoResetKey(k => k + 1);
    resetAlumnoPending.current = false;
  }
}, [alumnosAuditoria]);

  const [showAlumnoError, setShowAlumnoError] = useState(false);

  const filter: any = useRef();

  const handleSelectedSociety = (e: any) => {
    setSociedadesSelectValue(JSON.stringify(e.detail));

    const sociedadSelected = e.detail.map(
      (sociedad: { value: { ID_SOCIEDAD: any } }) => sociedad.value.ID_SOCIEDAD
    );

    dispatch(removeSelectedProvinciasAuditoria());
    dispatch(removeSelectedCursosAuditoria());
    dispatch(resetSelectedStudents());
    setProvinciasSelectValue('[]');
    setCursosSelectValue('[]');
    setAlumnosSelectValue('[]');

    /*
    * Al cambiar Sociedad se van a actualizar las opciones
    * de Provincia, Curso y Alumno.
    *
    * Permitimos un único remount cuando lleguen esas opciones.
    */
    resetProvinciaPending.current = true;
    resetCursoPending.current = true;
    resetAlumnoPending.current = true;

    dispatch(setSelectedSociedadAuditoria(sociedadSelected));
    filter.current = {
      ...filter.current,
      sociedades: sociedadSelected.join(','),
      provincias: '',
      cursos: '',
      alumnos: ''
    };
  };

  const handleProvinceSelected = (e: any) => {
    setProvinciasSelectValue(JSON.stringify(e.detail));

    dispatch(removeSelectedCursosAuditoria());
    dispatch(resetSelectedStudents());
    setCursosSelectValue('[]');
    setAlumnosSelectValue('[]');

    /*
    * Provincia provoca que cambien Curso y Alumno.
    *
    * NO remontamos Provincia porque es precisamente
    * la selección que queremos conservar.
    */
    resetCursoPending.current = true;
    resetAlumnoPending.current = true;

    dispatch(setSelectedProvinciaAuditoria(e.detail));

    const provinciaSelected = e.detail.map(
      (provincia) => provincia.value
    );

    filter.current = {
      ...filter.current,
      provincias: provinciaSelected.join(','),
      cursos: '',
      alumnos: ''
    };
  };

  const handleSelectedCourse = (e: any) => {
    setCursosSelectValue(JSON.stringify(e.detail));

    dispatch(resetSelectedStudents());
    setAlumnosSelectValue('[]');

    /*
    * Al cambiar Curso se actualizan los alumnos.
    * Solamente Alumno necesita reinicializarse.
    */
    resetAlumnoPending.current = true;

    const courses = e.detail.map((course: any) => course.value.ID_CURSO);
    dispatch(setSelectedCursosAuditoria(courses));

    filter.current = {
      ...filter.current,
      cursos: courses.join(',')
    };
  };

  const handleStudentSelected = (e: any) => {
      setAlumnosSelectValue(JSON.stringify(e.detail));

      const selectedAlumno = e.detail.map(
        (alumno: any) => alumno.value.ID_ALUMNO
      );
      dispatch(setSelectedAlumno(selectedAlumno));
      const hayCursosSeleccionados =filter.current?.cursos && filter.current.cursos.trim() !== '';

    if (!hayCursosSeleccionados) {
      resetCursoPending.current = true;
      dispatch(getFilterCursosByAlumnosAuditoriaRequest(selectedAlumno.join(',')));
    }
    setShowAlumnoError(!hasAlumnoFilter(e.detail));
    filter.current = {
      ...filter.current,
      alumnos: selectedAlumno.join(',')
    };
  };

  const cleanFilterAuditoria = () => {
    deleteSavedPagination(window.location.pathname);
    setSelectedOptionFilter(false);
    setIsFilterActive(false);
    setOptionsFilter('');
    setSelectedFilter({});
    setSelectedFilterName('');
    setSelectedFilterId('');
    setSociedadesSelectValue('[]');
    setProvinciasSelectValue('[]');
    setCursosSelectValue('[]');
    setAlumnosSelectValue('[]');
    setSelectedFiltros('[]');

    setShowAlumnoError(false);

    filter.current = {
      sociedades: '',
      provincias: '',
      cursos: '',
      alumnos: '',
    };

    resetSociedadPending.current = true;
    resetProvinciaPending.current = true;
    resetCursoPending.current = true;
    resetAlumnoPending.current = true;

    dispatch(resetSelectedStudents());
    dispatch(removeFilterAuditoria());
    dispatch(removeFiltro());

    dispatch(getSociedadesRequest());
    dispatch(getFiltrosRequest());
    dispatch(setPracticasAuditoria([]));
    dispatch(setPracticasAuditoriaCount(0));
  };

  const cleanFilters = () => {
    deleteSavedPagination(window.location.pathname);
    cleanFilterAuditoria();
  };

  const handlerSubmitFilters = () => {
    const hasError = !hasAlumnoFilter(selectedStudents);
    setShowAlumnoError(hasError);

    if (!hasError) {
      deleteSavedPagination(window.location.pathname);
      dispatch(submitFilters());
    }
  };

  const hasAlumnoFilter = (alumnos): boolean => {
    return Array.isArray(alumnos) && !!alumnos.length;
  };


  const parseSociedadesFiltro = (): { label: string; value: any; active?: string }[] => {
    let parsedSociedades: { label: string; value: any; active?: string }[] = [];

    try {
      parsedSociedades = typeof sociedadesFiltro === 'string' ? JSON.parse(sociedadesFiltro) : sociedadesFiltro;
    } catch (error) {
      parsedSociedades = [];
    }

    return parsedSociedades;
  };

  const parseProvinciasFiltro = (): { label: string; value: any; active?: string }[] => {
    let parsedProvincias: { label: string; value: any; active?: string }[] = [];

    try {
      parsedProvincias = typeof provinciasFiltro === 'string' ? JSON.parse(provinciasFiltro) : provinciasFiltro;
    } catch (error) {
      parsedProvincias = [];
    }

    return parsedProvincias;
  };

  const parseCursosFiltro = (): { label: string; value: any; active?: string }[] => {
    let parsedCursos: { label: string; value: any; active?: string }[] = [];

    try {
      parsedCursos = typeof cursosFiltro === 'string' ? JSON.parse(cursosFiltro) : cursosFiltro;
    } catch (error) {
      parsedCursos = [];
    }

    return parsedCursos;
  };

  const parseAlumnosFiltro = (): { label: string; value: any; active?: string }[] => {
    let parsedAlumnos: { label: string; value: any; active?: string }[] = [];

    try {
      parsedAlumnos = typeof alumnosFiltro === 'string' ? JSON.parse(alumnosFiltro) : alumnosFiltro;
    } catch (error) {
      parsedAlumnos = [];
    }

    return parsedAlumnos;
  };

  const buildUpdatedSociedades = (filtroValue: any) => {
    const parsedSociedades = parseSociedadesFiltro();
    let updatedSociedades: { label: string; value: any; active: string }[] = [];

    if (Array.isArray(parsedSociedades)) {
      const uniqueSociedades = new Set<string>();
      updatedSociedades = parsedSociedades
        .filter((sociedad) => filtroValue.sociedades?.split(',').includes(sociedad.value.ID_SOCIEDAD))
        .filter((sociedad) => {
          if (uniqueSociedades.has(sociedad.value.ID_SOCIEDAD)) {
            return false;
          } else {
            uniqueSociedades.add(sociedad.value.ID_SOCIEDAD);
            return true;
          }
        })
        .map((sociedad) => ({
          ...sociedad,
          active: 'true',
        }));
    }

    const filtroValueSociedades = filtroValue.sociedades ? filtroValue.sociedades.split(',') : [];
    filtroValueSociedades.forEach((sociedadId) => {
      if (!updatedSociedades.some((sociedad) => sociedad.value.ID_SOCIEDAD === sociedadId)) {
        const sociedadPractica = parsedSociedades.find((sociedad) => sociedad.value.ID_SOCIEDAD === sociedadId);
        if (sociedadPractica) {
          updatedSociedades.push({
            label: `${sociedadId} - ${sociedadPractica.value.NOMBRE_SOCIEDAD}`,
            value: sociedadPractica.value,
            active: 'true',
          });
        }
      }
    });

    return updatedSociedades;
  };

  const buildUpdatedProvincias = (filtroValue: any) => {
    const parsedProvincias = parseProvinciasFiltro();
    let updatedProvincias: { label: string; value: any; active: string }[] = [];

    if (Array.isArray(parsedProvincias)) {
      const uniqueProvincias = new Set<string>();
      updatedProvincias = parsedProvincias
        .filter((provincia) => filtroValue.provincias?.split(',').includes(provincia.value))
        .filter((provincia) => {
          if (uniqueProvincias.has(provincia.value)) {
            return false;
          } else {
            uniqueProvincias.add(provincia.value);
            return true;
          }
        })
        .map((provincia) => ({
          ...provincia,
          active: 'true',
        }));
    } else {
      console.error('parsedProvincias', parsedProvincias);
    }

    const filtroValueProvincias = filtroValue.provincias ? filtroValue.provincias.split(',') : [];
    filtroValueProvincias.forEach((provinciaId) => {
      if (!updatedProvincias.some((provincia) => provincia.value === provinciaId)) {
        const provinciaPractica = parsedProvincias.find((provincia) => provincia.value === provinciaId);
        if (provinciaPractica) {
          updatedProvincias.push({
            label: `${provinciaId} - ${provinciaPractica.label.split(' - ')[1]}`,
            value: provinciaPractica.value,
            active: 'true',
          });
        }
      }
    });

    return updatedProvincias;
  };

  const buildUpdatedCursos = (filtroValue: any) => {
    const parsedCursos = parseCursosFiltro();
    let updatedCursos: { label: string; value: any; active: string }[] = [];

    if (Array.isArray(parsedCursos)) {
      const uniqueCursos = new Set<string>();
      updatedCursos = parsedCursos
        .filter((curso) => filtroValue.cursos?.split(',').includes(curso.value.ID_CURSO.toString()))
        .filter((curso) => {
          if (uniqueCursos.has(curso.value.ID_CURSO.toString())) {
            return false;
          } else {
            uniqueCursos.add(curso.value.ID_CURSO.toString());
            return true;
          }
        })
        .map((curso) => ({
          ...curso,
          active: 'true',
        }));
    }

    const filtroValueCursos = filtroValue.cursos ? filtroValue.cursos.split(',') : [];
    filtroValueCursos.forEach((cursoId) => {
      if (!updatedCursos.some((curso) => curso.value.ID_CURSO.toString() === cursoId)) {
        const cursoPractica = parsedCursos.find((curso) => curso.value.ID_CURSO.toString() === cursoId);
        if (cursoPractica) {
          updatedCursos.push({
            label: `${cursoId} - ${cursoPractica.value.NOMBRE_CURSO}`,
            value: cursoPractica.value,
            active: 'true',
          });
        }
      }
    });

    return updatedCursos;
  };

  const buildUpdatedAlumnos = (filtroValue: any) => {
    const parsedAlumnos = parseAlumnosFiltro();
    let updatedAlumnos: { label: string; value: any; active: string }[] = [];

    if (Array.isArray(parsedAlumnos)) {
      const uniqueAlumnos = new Set<string>();
      updatedAlumnos = parsedAlumnos
        .filter((alumno) => filtroValue?.alumnos.split(',').includes(alumno.value.ID_ALUMNO))
        .filter((alumno) => {
          if (uniqueAlumnos.has(alumno.value.ID_ALUMNO)) {
            return false;
          } else {
            uniqueAlumnos.add(alumno.value.ID_ALUMNO);
            return true;
          }
        })
        .map((alumno) => ({
          ...alumno,
          active: 'true',
        }));
    } else {
      console.error(parsedAlumnos);
    }

    const filtroValueAlumnos = filtroValue.alumnos ? filtroValue.alumnos.split(',') : [];
    filtroValueAlumnos.forEach((alumnoId) => {
      if (!updatedAlumnos.some((alumno) => alumno.value.ID_ALUMNO === alumnoId)) {
        const alumnoPractica = parsedAlumnos.find((alumno) => alumno.value.ID_ALUMNO === alumnoId);
        if (alumnoPractica) {
          updatedAlumnos.push({
            label: `${alumnoId} - ${alumnoPractica.value.NOMBRE_ALUMNO}`,
            value: alumnoPractica.value,
            active: 'true',
          });
        }
      }
    });

    return updatedAlumnos;
  };


  //Filtro
  const handleSelectedFiltros = (e) => {
    setSelectedOptionFilter(true);
    const filtroSeleccionado = e.detail;
    setSelectedFilterName(filtroSeleccionado.label);
    const filtroId = filtroSeleccionado.label.split(' - ')[0];
    setSelectedFilterId(filtroId);
    const filtroValue = JSON.parse(filtroSeleccionado.value);

    setSelectedFilter({
      alumnos: filtroValue.alumnos,
      sociedades: filtroValue.sociedades,
      cursos: filtroValue.cursos,
      provincias: filtroValue.provincias,
    });

    const updatedSociedades = buildUpdatedSociedades(filtroValue);
    const updatedProvincias = buildUpdatedProvincias(filtroValue);
    const updatedCursos = buildUpdatedCursos(filtroValue);
    const updatedAlumnos = buildUpdatedAlumnos(filtroValue);

    const selectedAlumnoIds = updatedAlumnos.map(alumno => alumno.value.ID_ALUMNO);
    dispatch(setSelectedAlumno(selectedAlumnoIds));
    setAlumnosSelectValue(JSON.stringify(updatedAlumnos));
    setShowAlumnoError(!hasAlumnoFilter(updatedAlumnos));

    const combinedOptions = [
      ...updatedSociedades,
      ...updatedProvincias,
      ...updatedCursos,
      ...updatedAlumnos,
    ];

    setOptionsFilter(JSON.stringify(combinedOptions));
    setIsFilterActive(true);

    filter.current = {
      ...selectedFilter,
      cursos: filtroValue.cursos,
      sociedades: filtroValue.sociedades,
      provincias: filtroValue.provincias,
      alumnos: filtroValue.alumnos
    };

  };

  const [selectedFiltros, setSelectedFiltros]: [any, any] = useState('');
  const [selectedFilterName, setSelectedFilterName] = useState('');
  const [selectedOptionFilter, setSelectedOptionFilter] = useState(false);
  const [modalCerradoFiltroGuardarType, setModalCerradoFiltroGuardarType] = useState('');
  const [modalCerradoFiltroEliminarType, setModalCerradoFiltroEliminarType] = useState('');
  const [modalCerradoFiltroEditarType, setModalCerradoFiltroEditarType] = useState('');
  const [selectedFilterId, setSelectedFilterId] = useState('');
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [optionsFilter, setOptionsFilter] = useState('');
  const [selectedFilter, setSelectedFilter] = useState({});

  const openModalGuardarFiltroCerrado = () => {
    setModalCerradoFiltroGuardarType('empty');
  }

  const closeModalGuardarFiltroCerrado = () => {
    setModalCerradoFiltroGuardarType('');
  };

  const handleChangeFiltroNombre = (e: string) => {
    dispatch(setFiltroNombre(e));
  };

  const handleClickConfirmFilterButton = () => {
    const filtroDatos = filter.current;
    const nombrePag = links[0].label;
    const pagina = dispatch(setFiltroNombrePagina(nombrePag));
    const filtroJson = dispatch(setFiltroJson(filtroDatos));
    dispatch(guardarFiltroRequest(pagina, filtroJson));
    history.push(RouteTypes.HOME);
    history.push(RouteTypes.AUDIT);
  };

  const filterNameAdd: boolean = useMemo(() => {
    return !!nombreFiltro;
  }, [nombreFiltro]);

  //Editar filtro
  const openModalEditarFiltroCerrado = () => {
    setModalCerradoFiltroEditarType('confirm');
  };

  const closeModalEditarFiltroCerrado = () => {
    setModalCerradoFiltroEditarType('');
  };

 const confirmModalEditarFiltroCerrado = (filterName: string) => {
    handleClickEditarFiltroButton(filterName);
  };

  const handleClickEditarFiltroButton = (filterName: string) => {
    setModalCerradoFiltroEditarType('');

    const filtroDatos = filter.current;
    const nombrePag = links[0].label;
    const filtroIdString = String(selectedFilterId);
    const pagina = dispatch(setFiltroNombrePagina(nombrePag));
    const filtroJson = dispatch(setFiltroJson(filtroDatos));
    const nombreFiltro = filterName.split(' - ')[1];
    const filtroSeleccionado = filtro.find(filtro => filtro.NOMBRE_FILTRO === nombreFiltro);
    const fechaCreacion = filtroSeleccionado.FECHA_CREACION;
    const fechaModificacion = getActualTime();

    dispatch(setFiltroNombre(nombreFiltro));
    dispatch(setFiltroId(filtroIdString));
    dispatch(setFiltroFechaCreacion(fechaCreacion));
    dispatch(setFiltroFechaModificacion(fechaModificacion));
    dispatch(editarFiltroRequest(filtroJson, pagina));
    history.push(RouteTypes.HOME);
    history.push(RouteTypes.AUDIT);
  }

  //Eliminar filtro
  const openModalEliminarFiltroCerrado = () => {
    setModalCerradoFiltroEliminarType('confirm');
  }

  const closeModalEliminarFiltroCerrado = () => {
    setModalCerradoFiltroEliminarType('');
  }

  const confirmModalEliminarFiltroCerrado = () => {
    handleClickEliminarFiltroButton();
  };

  const handleClickEliminarFiltroButton = () => {
    setModalCerradoFiltroEliminarType('');
    const filtroIdString = String(selectedFilterId);
    dispatch(setFiltroId(filtroIdString));
    dispatch(eliminarFiltroRequest(filtroIdString));
    history.push(RouteTypes.HOME);
    history.push(RouteTypes.AUDIT);
  }

  return (
    <>
      <RfUiAccordionCustom className="rf-accordion">
        <h2 className="rf-title rf-accordion__title">Filtrado</h2>
        <button
          className="rf-accordion__button rf-ui-accordion-custom__button"
          data-toggle="collapse"
          aria-expanded="false"
        >
          Mostrar filtros
        </button>
        <form
          id="courseForm"
          className="rf-accordion__content rf-ui-accordion-custom__panel collapse"
        >
          <div className="rf-box">
            {(profileActive?.ID_PERFIL === '511' || profileActive?.ID_PERFIL === '611') ? (
              <div className="rf-practice-list__input-container">
                <RfUiMultiselect
                  key={`multiselect-sociedades-${sociedadResetKey}`}
                  withoutOptionsText={language.validations.noOptions}
                  textError={language.validations.multiselectEmpty}
                  textLabel="Sociedad"
                  placeholder="Seleccione sociedad"
                  defaultChecks={sociedadesSelectValue}
                  options={sociedades}
                  onOptionSelected={(e: any) => {
                    handleSelectedSociety(e);
                  }}
                  optionsFilter={optionsFilter}
                  isFilterActive={isFilterActive}
                />
              </div>
            ) : undefined}
            <div className="rf-practice-list__input-container">
              <RfUiMultiselect
                key={`multiselect-provincias-${provinciaResetKey}`}
                withoutOptionsText={language.validations.noOptions}
                textError={language.validations.multiselectEmpty}
                textLabel="Provincia"
                defaultChecks={provinciasSelectValue}
                options={provinciasAuditoriaParse}
                onOptionSelected={(e: any) => {
                  handleProvinceSelected(e);
                }}
                placeholder="Seleccione provincia"
                optionsFilter={optionsFilter}
                isFilterActive={isFilterActive}
              />
            </div>
          </div>
          <div className="rf-box">
            <div className="rf-practice-list__input-container">
              <RfUiMultiselect
                key={`multiselect-cursos-${cursoResetKey}`}
                withoutOptionsText={language.validations.noOptions}
                textError={language.validations.multiselectEmpty}
                textLabel="Curso"
                defaultChecks={cursosSelectValue}
                options={cursosAuditoria}
                placeholder="Seleccione curso"
                onOptionSelected={(e: any) => {
                  handleSelectedCourse(e);
                }}
                optionsFilter={optionsFilter}
                isFilterActive={isFilterActive}
              />
            </div>
            {profileActive?.ID_PERFIL === '111' ||
              profileActive?.ID_PERFIL === '112' ||
              profileActive?.ID_PERFIL === '121' ||
              profileActive?.ID_PERFIL === '122' ||
              profileActive?.ID_PERFIL === '123' ? (
              <div className="rf-practice-list__input-container">
                <RfUiInput
                  label="Alumno"
                  value={
                    profileActive?.ID_USUARIO +
                    ' - ' +
                    profileActive?.NOMBRE_USUARIO
                  }
                  disabled={true}
                  error=""
                ></RfUiInput>
              </div>
            ) : (
              <>
                <div className="rf-practice-list__input-container">
                  <RfUiMultiselect
                    key={`multiselect-alumnos-${alumnoResetKey}`}
                    withoutOptionsText={language.validations.noOptions}
                    textError={language.validations.multiselectEmpty}
                    options={alumnosAuditoria}
                    defaultChecks={alumnosSelectValue}
                    textLabel="Alumno"
                    placeholder="Seleccione un alumno"
                    onOptionSelected={(e: any) => {
                      handleStudentSelected(e);
                    }}
                    optionsFilter={optionsFilter}
                    isFilterActive={isFilterActive}
                  />
                </div>
                {showAlumnoError && (
                  <ErrorMessage message="El filtro alumno es obligatorio"></ErrorMessage>
                )}
              </>
            )}
            <div className="rf-practice-list__input-container">
              <RfUiSelect
                withoutOptionsText={language.validations.noOptions}
                textError={language.validations.multiselectEmpty}
                options={filtros}
                defaultChecked={selectedFiltros}
                label="Filtros"
                onOptionActive={handleSelectedFiltros}
                placeholder="Seleccione Filtro"
                optionFilter={selectedOptionFilter}
                onEdit={openModalEditarFiltroCerrado}
                onDelete={openModalEliminarFiltroCerrado}
              />
            </div>
            <div
              className={`rf-flex rf-justify-end rf-align-center rf-text-align-right
             ${isMobileOnly
                  ? 'rf-block--mobile rf-text-align-center--mobile'
                  : ''
                }`}
            >
              <RfUiButton
                text="Guardar filtros"
                text-help="Guardar filtros"
                aspect="secondary"
                onButtonClick={() => {
                  openModalGuardarFiltroCerrado();
                }}
              >
                {' '}
              </RfUiButton>
              <RfUiButton
                text="Limpiar filtros"
                text-help="Limpiar filtros"
                aspect="secondary"
                onButtonClick={() => {
                  cleanFilters();
                }}
              >
                {' '}
              </RfUiButton>
              <RfUiButton
                text="Filtrar"
                type="button"
                aspect="primary"
                className="rf-button rf-margin-left-30"
                onButtonClick={() => {
                  handlerSubmitFilters();
                }}
              >
                {' '}
              </RfUiButton>
            </div>
          </div>
        </form>
        <div>
          <RfUiModal
            title-Modal={'Nombre filtro'}
            id-modal="empty"
            modal-type={modalCerradoFiltroGuardarType}
            slot-content={true}
            onModalClose={(e: any) => {
              closeModalGuardarFiltroCerrado();
            }}
            onConfirm={() => {
              handleClickConfirmFilterButton();
            }}
          >
            <div slot="content">
              <FilterContainer
                title={language.filter.filterName}
                valueFilter={nombreFiltro}
                handleFilterChange={handleChangeFiltroNombre}
              />
            </div>
            <div slot="content">
              <RfUiButton
                disabled={!filterNameAdd}
                text={language.filter.sendConfirm}
                type="button"
                aspect="white"
                className="rf-button"
                onButtonClick={handleClickConfirmFilterButton}
              >
              </RfUiButton>
            </div>
          </RfUiModal>
        </div>
        <div>
          <RfUiModal
            title-Modal={`Usted va a editar el filtro: ${selectedFilterName}`}
            id-modal="moralEdit"
            modal-type={modalCerradoFiltroEditarType}
            required-slot={false}
            onModalClose={() => {
              closeModalEditarFiltroCerrado();
            }}
            onConfirm={() => {
              confirmModalEditarFiltroCerrado(selectedFilterName);
            }}
          >
          </RfUiModal>
        </div>
        <div>
          <RfUiModal
            title-Modal={`¿Esta seguro de que quiere eliminar el filtro? ${selectedFilterName}`}
            id-modal="modalDelete"
            modal-type={modalCerradoFiltroEliminarType}
            required-slot={true}
            onModalClose={(e: any) => {
              closeModalEliminarFiltroCerrado();
            }}
            onConfirm={() => {
              confirmModalEliminarFiltroCerrado();
            }}
          >
          </RfUiModal>
        </div>
      </RfUiAccordionCustom>
    </>
  );
};

export default FilterAudit;
